import { Loader } from "@/components/Loader/Loader";
import { chargingPoolQueryOptions } from "@/modules/charging-pool/queries/useChargingPool.query";
import { chargingPoolOffersQueryOptions } from "@/modules/charging-pool/queries/useChargingPoolOffers.query";
import { ChargingSpotsPage } from "@/pages/ChargingSpotsPage/ChargingSpotsPage";
import { NotFoundPage } from "@/pages/NotFoundPage/NotFoundPage";
import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/qrs/$evseId/spots")({
	loader: async ({ params, context }) => {
		const pool = await context.queryClient.ensureQueryData(chargingPoolQueryOptions(params.evseId));
		const chargingPoolId = pool?.chargingPool?.chargingPoolId;

		if (!chargingPoolId) {
			throw notFound();
		}

		const offersData = await context.queryClient.ensureQueryData(chargingPoolOffersQueryOptions(chargingPoolId));

		if ((offersData?.chargingPoolOffers?.offers.length ?? 0) === 0) {
			throw notFound();
		}

		return { chargingPoolId };
	},
	staticData: {
		theme: "light",
	},
	pendingComponent: Loader,
	notFoundComponent: NotFoundPage,
	errorComponent: NotFoundPage,
	component: ChargingSpotsPage,
});
